import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  background?: string;
  color?: string;
};

const AvatarOne: FC<Props> = ({
  background = colors['--slate'],
  color = colors['--body'],
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    style={{ background, borderRadius: '9px' }}
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M10.284 12.836c0 .546.431.99.963.99h.77a.976.976 0 00.963-.99v-.841a.976.976 0 00-.963-.99h-.77a.976.976 0 00-.963.99v.84zM19.02 12.836c0 .546.431.99.963.99h.77a.976.976 0 00.963-.99v-.841a.976.976 0 00-.963-.99h-.77a.976.976 0 00-.963.99v.84z"
      clipRule="evenodd"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M22.486 9c.532 0 .963.443.963.99v.79c0 .547.43.99.962.99h.626c.532 0 .963.443.963.99v3.611c0 .547-.431.99-.963.99h-6.643a.976.976 0 00-.962.989v.89c0 .547.43.99.962.99h6.643c.532 0 .963.443.963.99v.79c0 .547-.431.99-.963.99h-6.835a.976.976 0 01-.963-.99v-.79a.976.976 0 00-.963-.99H15.7a.976.976 0 01-.963-.99V9.99c0-.547.43-.99.963-.99h6.787zm.818 4.6c0 .547-.43.99-.962.99h-3.948a.976.976 0 01-.962-.99v-.84c0-.547.43-.99.962-.99h3.948c.531 0 .962.443.962.99v.84z"
      clipRule="evenodd"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M9.514 9a.976.976 0 00-.963.99v.79c0 .547-.43.99-.962.99h-.626a.976.976 0 00-.963.99v3.611c0 .547.431.99.963.99h6.643c.531 0 .963.442.963.989v.89c0 .547-.432.99-.963.99H6.963a.976.976 0 00-.963.99v.79c0 .547.431.99.963.99h6.835a.976.976 0 00.963-.99v-.79c0-.547.431-.99.963-.99h.577a.976.976 0 00.963-.99V9.99a.976.976 0 00-.963-.99H9.514zm-.818 4.6c0 .547.43.99.962.99h3.948a.976.976 0 00.963-.99v-.84a.976.976 0 00-.963-.99H9.658a.976.976 0 00-.962.99v.84z"
      clipRule="evenodd"
    />
  </svg>
);

export default AvatarOne;
